import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PublicFooter } from '../../components/public/PublicFooter.js';
import { PublicNav } from '../../components/public/PublicNav.js';

export function SupportPage() {
  useEffect(() => {
    document.title = 'Support — ScrubLedger';
  }, []);

  return (
    <div className="public-page">
      <PublicNav />
      <main className="public-simple-page">
        <div className="public-simple-page__card public-support-card">
          <h1>ScrubLedger Support</h1>
          <p>
            Need help with your ScrubLedger account, clinical documentation, program setup, or another
            issue? Our support team is here to help.
          </p>
          <p className="public-support-email">
            Email us at{' '}
            <a href="mailto:support@scrubledger.com">support@scrubledger.com</a>
          </p>
          <p>
            When contacting support, please include your name, institution, program, and a brief description
            of the issue so we can assist you as quickly as possible.
          </p>

          <section className="public-support-prospect" aria-labelledby="prospect-heading">
            <h2 id="prospect-heading">Interested in ScrubLedger for your program?</h2>
            <p>Schedule a walkthrough tailored to your Surgical Technology or clinical education program.</p>
            <Link to="/request-demo" className="btn btn--primary">Request a Demo</Link>
          </section>

          <div className="public-simple-page__actions">
            <Link to="/" className="btn btn--ghost">Back to home</Link>
            <Link to="/login" className="btn btn--secondary">Sign In</Link>
          </div>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
